export function isLoggedIn() {
  return !!localStorage.getItem("@fpToken");
}
